module.exports = __webpack_public_path__ + "0074c2b238b052fef04f08b567240940.pdf";